<template>
  <div class="image-count">
    {{ current }}/{{ total }}
  </div>
</template>

<script>
export default {
  props: {
    current: Number,
    total: Number
  }
}
</script>

<style lang="scss" scoped>
.image-count {
  background: #E95D15;
  box-shadow: 5px 3px 6px rgba(0,0,0,0.37);
  font-size: 30px;
  font-weight: bold;
  line-height: 63px;
  position: absolute;
  top: 0;
  left: 0;
  width: 106px;
  z-index: 2;
}
</style>